import { FaSpinner } from "react-icons/fa";

function Loading() {
  return (
    <div className="m-10 z-50">
        <span className="flex flex-wrap content-center justify-center z-50">
        <FaSpinner className="mt-1 mr-3 animate-spin z-50" />{" "}
        <span className="z-50">Loading...</span>
        </span>
    </div>
  );
}
export default Loading;
